export function formatCurrency(value) {
    const formatter = Intl.NumberFormat(undefined, {
        currency: 'GBP',
        currencyDisplay: 'symbol',
        minimumFractionDigits: 2,
        style: 'currency',
    });
    return formatter.format(value);
}
export function formatCurrencyWhole(value) {
    const formatter = Intl.NumberFormat(undefined, {
        currency: 'GBP',
        currencyDisplay: 'symbol',
        maximumFractionDigits: 0,
        style: 'currency',
    });
    return formatter.format(value);
}
